// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3I1Xn","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__grIvk"};